module.exports = `${require.publicPath}loadingBg.757024e3.gif`;